import { Box, Avatar, ActionList, ActionMenu } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Avatar,
  ActionList,
  ActionMenu,
  React
};